module.exports = __webpack_public_path__ + "static/media/sustained_riser_grey.e707448c.svg";